import { Filter } from '@vrplatform/components';
import { day } from '@vrplatform/utils';
import { Group } from '@mantine/core';
import { useGuestBalancesTableFilter } from './useGuestBalancesTableFilter';
import { CustomFilter } from '@vrplatform/table-filter';

export const GuestBalancesTableFilter = () => {
  return (
    <Group gap="xs">
      <EndDate />
      <BookingChannel />
    </Group>
  );
};

const EndDate = () => {
  const { filter, setQueryParams } = useGuestBalancesTableFilter();

  return (
    <Filter.Date
      value={[day(filter.endDate).toDate(), null]}
      clearable={false}
      setValue={(value) =>
        setQueryParams({
          endDate: value?.[0] ? day(value[0]).yyyymmdd() : null,
        })
      }
      type="single"
    />
  );
};

const BookingChannel = () => {
  const { filter, setQueryParams } = useGuestBalancesTableFilter();

  return (
    <CustomFilter.BookingChannel
      bookingChannels={filter.channels}
      setBookingChannels={(v) =>
        setQueryParams({ channels: v?.length ? v.join(',') : null })
      }
    />
  );
};
